const MapActions = {
    NOME_MODULO: "auth",
    ALTERAR_STATUS_LOGIN: "alterarStatusLogin",
    SALVAR_USUARIO_LOGADO: "salvarUsuarioLogado",
    DESLOGAR_USUARIO: "deslogarUsuario"
};

const MapActionsModule = {
    ALTERAR_STATUS_LOGIN: MapActions.NOME_MODULO + "/" + MapActions.ALTERAR_STATUS_LOGIN,
    SALVAR_USUARIO_LOGADO: MapActions.NOME_MODULO + "/" + MapActions.SALVAR_USUARIO_LOGADO,
    DESLOGAR_USUARIO: MapActions.NOME_MODULO + "/" + MapActions.DESLOGAR_USUARIO,
}

Object.freeze(MapActions);
Object.freeze(MapActionsModule);

export {MapActions, MapActionsModule};
